import { Injectable, signal } from '@angular/core';

/** Lets a sticky section (e.g. compare features) hide the website nav pill. */
@Injectable({ providedIn: 'root' })
export class WebsiteNavYieldService {
  private readonly _yielded = signal(false);
  readonly yielded = this._yielded.asReadonly();

  setYielded(yielded: boolean) {
    this._yielded.set(!!yielded);
  }
}
